import React from 'react'
import propTypes from 'prop-types'
import { Typography, makeStyles } from '@material-ui/core'
import DropDownZone from '../../../common/DropDownZone'

const MAX_BYTES = 50 * 1024 * 1024

const ACCEPT_BY_TYPE = {
	document: 'application/pdf,.pdf',
	image: 'image/jpeg,image/png',
	video: 'video/mp4,video/quicktime'
}

const HELPER_BY_TYPE = {
	document: 'PDF · max 50MB',
	image: 'JPG, PNG · max 50MB',
	video: 'MP4, MOV · max 50MB'
}

const useStyles = makeStyles((theme) => ({
	wrapper: {
		marginBottom: theme.spacing(2)
	},
	helper: {
		marginBottom: theme.spacing(1),
		color: theme.palette.text.secondary
	},
	selected: {
		marginTop: theme.spacing(1),
		padding: theme.spacing(1.5),
		backgroundColor: theme.palette.background.default,
		borderRadius: theme.shape.borderRadius
	},
	error: {
		marginTop: theme.spacing(0.5)
	}
}))

const formatBytes = (bytes) => {
	if (bytes < 1024) return `${bytes} B`
	if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
	return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}

const FileUploader = ({ type, file, error, onFileSelected }) => {
	const classes = useStyles()

	const handleFiles = (files) => {
		if (!files || files.length === 0) return
		const f = files[0]
		if (f.size > MAX_BYTES) {
			onFileSelected(null, 'File exceeds the 50 MB limit.')
			return
		}
		onFileSelected(f, null)
	}

	return (
		<div className={classes.wrapper}>
			<Typography variant='caption' className={classes.helper}>
				{HELPER_BY_TYPE[type]}
			</Typography>
			<DropDownZone
				multiple={false}
				accept={ACCEPT_BY_TYPE[type]}
				onFilesReceived={handleFiles}
				message={
					<Typography variant='body2' align='center'>
						Drag & drop a file here, or click to select
					</Typography>
				}
			/>
			{file && (
				<div className={classes.selected}>
					<Typography variant='body2'>
						<strong>{file.name}</strong> — file selected · {formatBytes(file.size)}
					</Typography>
				</div>
			)}
			{error && (
				<Typography variant='caption' color='error' className={classes.error}>
					{error}
				</Typography>
			)}
		</div>
	)
}

FileUploader.propTypes = {
	type: propTypes.oneOf(['document', 'image', 'video']).isRequired,
	file: propTypes.object,
	error: propTypes.string,
	onFileSelected: propTypes.func.isRequired
}

FileUploader.defaultProps = {
	file: null,
	error: null
}

export default FileUploader
